import styled from "styled-components";

const FooterCopyRightText = styled.div`
  display: block;
  text-align: left;

  @media (max-width: 575px) {
    text-align: center;
  }
`;
export default FooterCopyRightText;